import React from 'react'
import CssBaseline from '@material-ui/core/CssBaseline'
import Drawer from '@material-ui/core/Drawer'
import Hidden from '@material-ui/core/Hidden'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Box from '@material-ui/core/Box'
import { checkIfCurrentUserIsMedicalCardsUser} from 'utils/functions';
import { useStyles } from './Sidebar.styles'
import { tabs } from './Sidebar.constants'

const Logo =
  'http://d1ohqf92fg2anw.cloudfront.net/emails-material/img/blue-logo.png'

const Sidebar = props => {
  const { container, onSidebarTabSelect, selectedItem } = props
  const classes = useStyles()
  const [mobileOpen, setMobileOpen] = React.useState(false)
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen)
  }

  // here we need to show 'medical cards' tab only for specific users in production env.
  // and for other users we will hide this tab and show the rest of the tabs
  let tabsToRender = tabs;

  if (process.env.REACT_APP_MEDICAL_CARDS_USERS) {
    const isMedicalCardsUser = checkIfCurrentUserIsMedicalCardsUser();
    if (isMedicalCardsUser) 
      tabsToRender = ['medical cards'];
    else tabsToRender = tabs.filter(tabItem => tabItem !== 'medical cards');
  }


  const drawer = (
    <div>
      <Box display="flex" justifyContent="center" m={2}>
        <img className={classes.logo} src={Logo} alt="logo" />
      </Box>
      <div className={classes.toolbar} />

      <List>
        {tabsToRender.map((text, index) => (
          <ListItem
            onClick={() => onSidebarTabSelect(text)}
            className={classes.sidebarListItem}
            button
            key={index}
            selected={text === selectedItem}
          >
            <ListItemText key={index} className ={classes.sidebarListItemText} primary={text} />
          </ListItem>
        ))}
      </List>
    </div>
  )
  return (
    <div className={classes.root}>
      <CssBaseline />
      <nav className={classes.nav}>
        <Hidden smUp implementation="css">
          <Drawer
            container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper
            }}
            ModalProps={{
              keepMounted: true // Better open performance on mobile.
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
        <Hidden xsDown implementation="css">
          <Drawer
            classes={{
              paper: classes.drawerPaper
            }}
            variant="permanent"
          >
            {drawer}
            <List></List>
          </Drawer>
        </Hidden>
      </nav>
    </div>
  )
}

export default Sidebar
